// import './App.css';
import { Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import AboutUs from "./Frontend/Pages/AboutUs";
import ContactUs from "./Frontend/Pages/ContactUs";
import Home from "./Frontend/Pages/Home";
import TrackPage from "./Frontend/Pages/TrackPage";
import Navbar from "./Frontend/Navbar/Navbar";
import Footer from "./Frontend/Pages/Footer"; // Ensure this import matches your file naming
import IraqOffice from "./Frontend/Offices/IraqOffice";
import UKOffices from "./Frontend/Offices/UKOffices";
import Clearance from "./Frontend/Service/Clearance";
import RoadTransport from "./Frontend/Service/RoadTransport";
import TheRest from "./Frontend/Service/TheRest";
import Wholesale from "./Frontend/Service/Wholesale";
import Payment from "./Frontend/WhatWeOffer/Payment";
import LowestPrice from "./Frontend/WhatWeOffer/LowestPrice";
import PrivacyPolicy from "./Frontend/Privacy/PrivacyPolicy";
import TermsAndConditions from "./Frontend/Privacy/TermsAndConditions";
import ModernSlaveryStatement from "./Frontend/Privacy/ModernSlaveryStatement";
import EventsAndCommunityPage from "./Frontend/Pages/EventsAndCommunityPage";
import FAQPage from "./Frontend/Pages/FAQPage";
import NotFound from "./Frontend/Pages/NotFound";
import { SearchPage } from "./Frontend/Pages/NavPages";
import PromotionsPage from "./Frontend/Pages/PromotionsPage";
import BrandsPage from "./Frontend/Pages/BrandsPage";
import BrandProductsPage from "./Frontend/Pages/BrandProductsPage";
import CartPage from "./Frontend/Pages/CartPage";
import ProductDetailsPage from "./Frontend/Pages/ProductDetailsPage";
import SignInPage from "./Frontend/Pages/SignInPage";
import RegisterPage from "./Frontend/Pages/RegisterPage";
import ProfilePage from "./Frontend/Pages/ProfilePage";
import QuoteHistoryPage from "./Frontend/Pages/QuoteHistoryPage";
import LocalDelivery from "./Frontend/Service/LocalDelivery";
import OurService from "./Frontend/Service/OurService";
function App() {
  return (
    <Box
      className="App"
      sx={{ m: 0, p: 0, width: "100%", maxWidth: "100%", overflowX: "hidden" }}
    >
      <Navbar />
      <Box
        component="main"
        sx={{
          pt: { xs: "32px", sm: "32px", md: "clamp(92px, 11vw, 120px)" },
          px: 0,
          mx: 0,
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Search" element={<SearchPage />} />
          <Route path="products" element={<SearchPage />} />
          <Route path="products/:id" element={<ProductDetailsPage />} />
          <Route path="Promotions" element={<PromotionsPage />} />
          <Route
            path="Brands/:brandId/products"
            element={<BrandProductsPage />}
          />
          <Route path="Brands" element={<BrandsPage />} />
          <Route path="Cart" element={<CartPage />} />
          <Route path="Track" element={<TrackPage />} />
          <Route path="AboutUs" element={<AboutUs />} />
          <Route path="ContactUs" element={<ContactUs />} />
          <Route path="OurServices" element={<OurService />} />
          <Route path="IraqOffice" element={<IraqOffice />} />
          <Route path="UKOffices" element={<UKOffices />} />
          <Route path="Customs_Clearance" element={<Clearance />} />
          <Route path="RoadTransport " element={<RoadTransport />} />
          <Route path="Export_Services" element={<TheRest />} />
          <Route path="Wholesale_Distribution" element={<Wholesale />} />
          <Route
            path="Logistics_Storage_Solutions"
            element={<LocalDelivery />}
          />

          <Route
            path="International_Transportation"
            element={<LowestPrice />}
          />
          <Route path="Payment" element={<Payment />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="TermsAndConditions" element={<TermsAndConditions />} />
          <Route
            path="ModernSlaveryStatement"
            element={<ModernSlaveryStatement />}
          />
          <Route
            path="EventsAndCommunity"
            element={<EventsAndCommunityPage />}
          />
          <Route path="FAQ" element={<FAQPage />} />
          <Route path="SignIn" element={<SignInPage />} />
          <Route path="Register" element={<RegisterPage />} />
          <Route path="Profile" element={<ProfilePage />} />
          <Route path="QuoteHistory" element={<QuoteHistoryPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
